import { render, staticRenderFns } from "./detail-item.vue?vue&type=template&id=f35238e2"
import script from "./detail-item.vue?vue&type=script&lang=js"
export * from "./detail-item.vue?vue&type=script&lang=js"
import style0 from "./detail-item.vue?vue&type=style&index=0&id=f35238e2&prod&lang=stylus"
import style1 from "./detail-item.vue?vue&type=style&index=1&id=f35238e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports